import {create} from 'zustand';

import {UnitsFetchStateStore} from './types';
import {OperationStateTypesEnum} from 'presentation/constants';

const useUnitsFetchStateStore = create<UnitsFetchStateStore>(set => ({
	unitListFetchState: OperationStateTypesEnum.PENDING,
	setUnitListFetchState: value => set({unitListFetchState: value}),
}));

export {useUnitsFetchStateStore};
